import '@/scss/components/ObjectList.css';
import { useMemo } from 'react';
import ActionsBadge from './Badge/Actions';
import AssetSpecialStatusBadge from './Badge/AssetSpecialStatus';
import DescriptionBadge from './Badge/Description';
import LegendsBadge from './Badge/Legend';
import MarketValueBadge from './Badge/MarketValue';
import OwnerBadge from './Badge/Owner';
import ReportDateBadge from './Badge/ReportDate';
import TitleBadge from './Badge/Title';
import { ObjectListItemType, ObjectListType } from './type';

export default function ObjectListItem(
  props: Omit<ObjectListType, 'objectItems'> & { item: ObjectListItemType }
) {
  const {
    type,
    icon,
    id,
    title,
    subtitle,
    reportDate,
    isAnnual,
    legends,
    description,
    isTitleEditable,
    status,
    marketValue,
    funds_legal_form,
    showOneRow,
    isGray,
  } = props.item;
  const actions = props.actions;

  const isOneRow = useMemo(() => {
    return showOneRow || !props.item || description === undefined || description.length === 0;
  }, [description, showOneRow, props.item]);

  return (
    <div className={`object-list-item ${isGray ? 'gray-object' : ''}`}>
      <div className="object-list-item-left object-list-item-icon">{icon}</div>
      <div className="object-list-item-right">
        <div className={`object-list-item-upper${isOneRow ? '-empty' : ''}`}>
          <div className="asset-information">
            <TitleBadge title={title} type={type} id={id} isTitleEditable={isTitleEditable} />
            {subtitle && <div className="title-sub">{subtitle}</div>}
            {reportDate && <ReportDateBadge reportDate={reportDate} isAnnual={isAnnual} />}
            <MarketValueBadge {...marketValue} />
            <LegendsBadge legends={legends} />
            <AssetSpecialStatusBadge translation={status?.translation} id={status?.id} />
            <OwnerBadge ownerLegalForms={funds_legal_form} />
          </div>
          <div className="object-list-item-upper-section-empty"></div>
          {actions ? (
            <div className="object-list-item-upper-right">
              <ActionsBadge actions={actions} type={type} id={id} />
            </div>
          ) : null}
        </div>
        {!isOneRow && (
          <div className="object-list-item-lower">
            <div className="lower-flex">
              <DescriptionBadge description={description} />
            </div>
            <div className="object-list-item-lower-section-empty"></div>
          </div>
        )}
      </div>
    </div>
  );
}
